const PAYMENT_METHOD_LABELS: Record<string, string> = {
  EFECTIVO: 'Efectivo',
  TRANSFERENCIA_BANCARIA: 'Transferencia bancaria',
  TRANSFERENCIA_MOVIL: 'Transferencia móvil',
  CHEQUE: 'Cheque',
  DEPOSITO_BANCARIO: 'Depósito bancario',
};

const PAYMENT_STATUS_LABELS: Record<string, string> = {
  PENDING: 'Pendiente',
  CONFIRMED: 'Confirmado',
  CANCELLED: 'Anulado',
  REFUNDED: 'Reembolsado',
  PARTIAL_REFUND: 'Reembolso parcial',
};

export function getPaymentMethodLabel(method?: string | null): string {
  if (!method) return 'Efectivo';
  return PAYMENT_METHOD_LABELS[method] || method;
}

export function getPaymentStatusLabel(status?: string | null): string {
  if (!status) return '—';
  return PAYMENT_STATUS_LABELS[status] || status;
}
